



























































import { Component, Vue } from 'vue-property-decorator'
import { MetaInfo } from 'vue-meta'
import { common } from '@/app/model/store/domain/const'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import CommonClass from '@/app/module/common'
import ExternalLinkSearch from '@/app/components/ExternalLink/ExternalLinkSearch.vue'
import ExternalLinkListApi from '@/app/model/api/externalLinkListApi'
import ExternalLinkBox from '@/app/components/ExternalLink/ExternalLinkBox.vue'

@Component({
  components: {
    ExternalLinkBox,
    ExternalLinkSearch,
    CommonHeader,
    Loading,
    ErrorModal
  },
  metaInfo (this: externalLink): MetaInfo {
    return {
      title: CommonClass.getServiceFunctionData().external_link.external_link_name + ' | ' + common.SYSTEM_NAME
    }
  }
})
export default class externalLink extends Vue {
  private externalLinkCount: number = 0
  private externalLinkContentCount: number = 0
  private externalLinkData: any = {}

  private notDataMessage: boolean = false
  private showLoading: boolean = true

  created () {
    if (this.$store.state.externalLinkState.selectedYear === 0) {
      this.$store.state.externalLinkState.selectedYear = (new Date()).getFullYear()
    }
    this.getExternalLinkList()
  }

  private getExternalLinkList () {
    (async () => {
      const result = await ExternalLinkListApi.getList(
        this.$store.state.externalLinkState.searchText,
        this.$store.state.externalLinkState.selectedYear
      )

      if (result.isOk()) {
        const payload = result.getPayload()

        if (payload.external_links.length === 0) {
          this.externalLinkCount = 0
          this.externalLinkContentCount = 0
          this.notDataMessage = true
        } else {
          this.externalLinkData = payload.external_links
          this.externalLinkCount = this.externalLinkData.length
          this.externalLinkContentCount = this.countExternalLinkContents(this.externalLinkData)
          this.notDataMessage = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private changeList () {
    this.showLoading = true
    this.scrollTop()
    this.getExternalLinkList()
  }

  private scrollTop () : any {
    const externalLinkArea: any = document.getElementById('listContainer')!
    externalLinkArea.scrollTop = 0
  }

  private countExternalLinkContents (data: any) {
    let contentsCount = 0
    for (const datum of data) {
      contentsCount += datum.external_link_contents.length
    }
    return contentsCount
  }
}
